import React, { useState, useEffect, useCallback } from 'react';
import { Table, Input, Button, App } from 'antd';
import axios from 'axios';
import server from 'util/Server';
import excelIcon from '../../assets/images/excel.png'
import PdfIcon from '../../assets/images/pdf.png'
import { objetoVacio } from 'util/utils';
import { generateExcel, generatePdf } from './services/services';
import Storage from 'util/store/Storage'
import './index.css'
import { sessionCaducada, setearMiles } from 'util/funciones';
import { exportTablePDF } from 'util/funcionesNews';
import { saveAs } from 'file-saver';
import * as XLSX from "xlsx";
import jsPDF from 'jspdf';

const MONEY_FIELDS = new Set([
    'precio',
    'subtotal_venta',
    'descuento',
    'recaudo',
    'total',
    'valor_descuento_total',
    'valor_venta_total',
    'precio_diferencial',
]);

const formatExportCell = (value: unknown, dataIndex: string): string | number => {
    if (value === undefined || value === null) return '';
    if (dataIndex === 'es_online') return value ? 'ONLINE' : 'OFFLINE';
    if (dataIndex === 'cantidad') return setearMiles(value);
    if (MONEY_FIELDS.has(dataIndex)) return `$${setearMiles(value)}`;
    return value as string | number;
};

const mapRowsForExcel = (rows: any[], tableColumns: any[]) =>
    rows.map((row) =>
        tableColumns.reduce((acc: Record<string, string | number>, col: any) => {
            acc[col.title] = formatExportCell(row[col.dataIndex], col.dataIndex);
            return acc;
        }, {})
    );

const SmartDataTable = ({ header = undefined, searchKey = 'search', handleIdRecord, onSelectChangeRow, idRecord, keyId = 'id', columns, autoLoad = false, nombre_reporte = 'Reporte', rowSelectionOn, nullUpdate, exportPDFLocal = false, ...props }: any) => {
    enum MESSAGE_STATUS {
        UNAUTORIZE = 'Request failed with status code 401',
    }
    const { notification } = App.useApp()
    const { usuario } = Storage.getState()
    const [data, setData] = useState<any[]>([]);
    const [loaderExcel, setLoaderExcel] = useState(false)
    const [loaderPDF, setLoaderPDF] = useState(false)
    const [sort, setSort] = useState<Record<string, number>>({})
    const [pagination, setPagination] = useState<any>({
      current: 1,
      pageSize: 20,
      showSizeChanger: false,
      hideOnSinglePage: false,
      total: 0
  });
    const [pageSize, setPageSize] = useState<number>(20);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [loading, setLoading] = useState<boolean>(false);
    const [searchText, setSearchText] = useState<string>('');
    const [filterDefaultValues, setFilterDefaultValues] = useState<Record<string, unknown>>({})

    const hasValidFilters = useCallback(() => (
        props.filterTabla?.fecha_inicial != undefined
        && props.filterTabla?.fecha_final != undefined
        && props.filterTabla?.identificadorEstacion != undefined
    ), [props.filterTabla])

    const closeSession = (error: any) => {
        if (error.message == MESSAGE_STATUS.UNAUTORIZE) {
            sessionCaducada()
        }
    }

    const fetchData = useCallback(async (options: {
        resetPage?: boolean
        filters?: Record<string, unknown>
        page?: number
        size?: number
        sortOverride?: Record<string, number>
    } = {}) => {
        const {
            resetPage = false,
            filters,
            page,
            size,
            sortOverride,
        } = options

        if (!hasValidFilters()) return

        const activeFilters = filters ?? filterDefaultValues
        const activePage = resetPage ? 1 : (page ?? currentPage)
        const activeSize = size ?? pageSize
        const activeSort = sortOverride ?? sort

        let query: Record<string, unknown> = {
            ...activeFilters,
            ...props.filterTabla,
            limit: activeSize,
            skip: resetPage ? 0 : (activePage - 1) * activeSize,
        }

        const searchValue = query[searchKey]
        if (typeof searchValue === 'string' && searchValue.trim() === '') {
            delete query[searchKey]
        }

        if (objetoVacio(activeSort)) {
            delete query.sort
        } else {
            query.sort = activeSort
        }

        try {
            props.hanldeLoading(true)
            setLoading(true)

            const { data: rows, total }: any = await axios.get<any>(
                `${props.apiUrl}`, { params: query, headers: { Authorization: server.obtenerToken() } }
            ).then(({ data }) => data)

            if (rows?.length == 0) {
                notification.info({ message: 'Sin información', description: 'No se encontraron datos entre las fechas seleccionadas', placement: 'bottomRight', duration: 5 })
                setData([])
            } else {
                setData(rows)
            }

            if (resetPage) {
                setCurrentPage(1)
            }

            setPagination((prev: any) => ({
                ...prev,
                current: resetPage ? 1 : activePage,
                pageSize: activeSize,
                total,
            }))

            nullUpdate?.()
        } catch (error: any) {
            closeSession(error)
            notification.error({ message: 'Ocurrió un error', description: 'No se pudo realizar la consulta, por favor intente mas tarde', placement: 'bottomRight', duration: 5 })
            console.error(error);
            nullUpdate?.()
        } finally {
            setLoading(false)
            props.hanldeLoading(false)
        }
    }, [
        currentPage,
        filterDefaultValues,
        hasValidFilters,
        nullUpdate,
        pageSize,
        props.apiUrl,
        props.filterTabla,
        props.hanldeLoading,
        searchKey,
        sort,
    ]);

    const handleSearch = () => {
        const nextFilters = { ...filterDefaultValues, [searchKey]: searchText }
        setFilterDefaultValues(nextFilters)
        setCurrentPage(1)
        fetchData({ resetPage: true, filters: nextFilters })
    }

    const generatePDF = async () => {
        try {
            setLoaderPDF(true)
            const result = await generatePdf({
                "name": nombre_reporte,
                "header": columns.map((column: any) => {
                    return {
                        header: column.title,
                        key: column.dataIndex,
                        width: 40
                    }
                }),
                userName: usuario.usuario,
                ...props.filterTabla
            }, props.genPdfUrl)

            let columnsPDF = columns.map((column: any) => {
              return {
                  header: column.title,
                  dataKey: column.dataIndex
              }
          })


            const { data: dataTablePdf } = result.data.data

            const parseData = dataTablePdf.map((data: any) => {
                return {
                    ...data,
                    precio: `$${setearMiles(data.precio)}`,
                    valor_descuento_total: `$${setearMiles(data.valor_descuento_total)}`,
                    precio_diferencial: `$${setearMiles(data.precio_diferencial)}`,
                    valor_venta_total: `$${setearMiles(data.valor_venta_total)}`

                }
            })

            const document: any = new jsPDF('l', 'pt', [2000, 1000], true)
            document.setFontSize(14)
            document.setFont('helvetica', 'italic')
            document.autoTable({
                startY: 50,
                body: parseData,
                columns: columnsPDF,
                styles: { fontSize: 20 },
                headStyles: { fillColor: [145, 145, 145] },
            })
            document.save(nombre_reporte + '.pdf')

            notification.info({ message: 'Generando archivo', description: `Estamos generando el archivo PDF, le notificaremos cuando este listo.`, placement: 'bottomRight', duration: 5 })
        } catch (error) {
            notification.error({ message: 'Ocurrió un error', description: 'Por favor intente nuevamente', placement: 'bottomRight', duration: 5 })
        } finally {
            setLoaderPDF(false)
        }
    }

    const generateLocalPDF = () => {
        try {
            if (data.length > 0) {
                const columnas = columns.map((column: any) => {
                    return {
                        header: column.title,
                        dataKey: column.dataIndex
                    }
                })

                const parseData = data.map(row => {
                    return {
                        ...row,
                        precio: `$${setearMiles(row.precio)}`,
                        cantidad: `${setearMiles(row.cantidad)}`,
                        valor_descuento_total: `$${setearMiles(row.valor_descuento_total)}`,
                        valor_venta_total: `$${setearMiles(row.valor_venta_total)}`,
                        subtotal_venta: `$${setearMiles(row.subtotal_venta)}`,
                        descuento: `$${setearMiles(row.descuento)}`,
                        recaudo: `$${setearMiles(row.recaudo)}`,
                        total: `$${setearMiles(row.total)}`,
                        es_online: row.es_online ? 'ONLINE' : 'OFFLINE'
                    }
                })
                exportTablePDF(parseData, columnas, props.tituloReporte ?? 'Reporte ventas consolidado')
            } else {
                notification.warning({ message: 'Notificación', description: `${usuario.usuario}, No se encuentran datos para exportar`, placement: 'bottomRight', duration: 5 })
            }
        } catch (error) {
            console.log('ERROR:::', error)
        }
    }

    const generateExcelTable = async () => {
        try {
            setLoaderExcel(true)

            const result = await generateExcel(({
                "name": nombre_reporte,
                "header": columns.map((column: any) => {
                    return {
                        header: column.title,
                        key: column.dataIndex,
                        width: 40
                    }
                }),
                userName: usuario.usuario,
                ...props.filterTabla
            }), props.genExcelUrl)

            const apiRows = result.data?.data ?? []
            const rowsForSheet = mapRowsForExcel(apiRows, columns)
            const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(rowsForSheet);
            const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
            const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
            const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
            const blob: Blob = new Blob([excelBuffer], {
                type: EXCEL_TYPE
            });
            saveAs(blob, nombre_reporte + ".xlsx");

            notification.info({ message: 'Generando archivo', description: 'Estamos generando el archivo excel, le notificaremos cuando este listo', placement: 'bottomRight', duration: 5 })
        } catch (error) {
            notification.error({ message: 'Ocurrió un error', description: 'Por favor intente nuevamente', placement: 'bottomRight', duration: 5 })
        } finally {
            setLoaderExcel(false)
        }
    }

    const handleOnChange = (event: any) => {
        setSearchText(event.target.value);
    }

    const handlePagination = (pag: any, _filter: any, sorter: any) => {
        const { column, order } = sorter
        const newSort = column && order
            ? { [column.dataIndex]: order === 'ascend' ? 1 : -1 }
            : {}
        const newPage = pag.current
        const newSize = pag.pageSize

        setSort(newSort)
        setCurrentPage(newPage)
        setPageSize(newSize)

        fetchData({
            resetPage: false,
            page: newPage,
            size: newSize,
            sortOverride: newSort,
        })
    };

    useEffect(() => {
        if (props.update != null) {
            setSearchText('')
            setFilterDefaultValues((prev) => {
                const next = { ...prev }
                delete next[searchKey]
                return next
            })
            fetchData({ resetPage: true })
        }
    }, [props.update])

    useEffect(() => {
        setData([])
    }, [props.apiUrl])

    return (
        <div>
            <div style={{ display: 'flex', alignContent: 'center', justifyContent: 'start', gap: '8px' }}>
                <Input.Search
                    id='btn-buscar'
                    data-cy='btn-buscar'
                    data-testid='btn-buscar'
                    placeholder="Buscar"
                    onChange={handleOnChange}
                    onSearch={handleSearch}
                    style={{ width: '25%' }}
                    value={searchText}
                />
                <Button id='btn-descargar-excel' data-cy={'btn-descargar-excel'} data-testid={'btn-descargar-excel'} loading={loaderExcel} type='default' >
                    <img src={excelIcon} onClick={generateExcelTable} alt="excelIcon" />
                </Button>
                <Button loading={loaderPDF} type='default' data-testid={'btn-descargar-pdf'} onClick={() => {
                    exportPDFLocal ? generateLocalPDF() : generatePDF()
                }} >
                    <img src={PdfIcon} alt="excelIcon" />
                </Button>
            </div>

            <Table
                onRow={ handleIdRecord ? (record, index) => {
                  return {
                    onClick: () => {
                      if (!idRecord) {
                        handleIdRecord(record[keyId], index)
                      }
                    }
                  }
                } : undefined}
                id='tabla-ventas'
                data-cy='tabla-ventas'
                data-testid="pagination"
                rowKey={keyId}
                className='smart-table'
                dataSource={data}
                columns={columns}
                title={header}
                loading={loading}
                pagination={{...pagination,
                  position: ['bottomRight', 'topRight']
                }}
                onChange={handlePagination}
                rowSelection={rowSelectionOn ? {
                  selectedRowKeys: idRecord,
                  onChange: onSelectChangeRow,
                  type: 'checkbox',
                  columnWidth: 48
                } : undefined}
                scroll={{ x: true }}
            />
        </div>
    );
};


export default SmartDataTable
